import { Command } from '@ckeditor/ckeditor5-core';
export default class ResizeMediaCommand extends Command {
    /**
     * @inheritDoc
     */
    refresh() {
        const editor = this.editor;
        const model = editor.model;
        const selection = model.document.selection;
        const selectedMedia = selection.getSelectedElement();

        this.isEnabled = selectedMedia && selectedMedia.name === 'media';
        this.value = selectedMedia ? { width: selectedMedia.getAttribute('width'), height: null } : null;
    }
    execute(options) {
        const editor = this.editor;
        const model = editor.model;
        const selection = model.document.selection;
        const selectedMedia = selection.getSelectedElement();

        model.change(writer => {
            writer.setAttribute('width', options.width, selectedMedia);
        });
    }
}
//# sourceMappingURL=resizemediacommand.js.map